
import { reactive, defineComponent } from 'vue'
import Button from '@/components/elements/Button.vue'
import ModalHpcrDoctor from '@/components/block/ModalHpcrDoctor.vue'
export default defineComponent({
  name: 'RegisterIntro',
  components: { Button, ModalHpcrDoctor },
  setup() {
    const hpcrDoctorModal = reactive({
      isShow: false
    })
    const closeHpcrDoctorModal = () => (hpcrDoctorModal.isShow = false)
    const openHpcrDoctorModal = () => (hpcrDoctorModal.isShow = true)

    return {
      hpcrDoctorModal,
      closeHpcrDoctorModal,
      openHpcrDoctorModal
    }
  }
})
